
import {  withRouter, Link } from "react-router-dom"
import SVHeaderItem from "./SVHeaderItem"
import {SVTopNav}  from "./SVTopNav";
import {SVFancyNav} from "./SVFancyNav"
import {StaticRouter} from 'react-router'

import React, { Suspense, lazy,useRef, useEffect, useState, useContext, useReducer, useCallback } from "react";

import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import TacosContainerPage from '../../views/TacosContainerPage'
import {ReguserContainerCom} from '../../containers'
import SVESOrderComPage from '../../views/SVESOrderComPage'
import SVTPOrderComPage from '../../views/SVTPOrderComPage'
import StoredcardsWithCustprofilePage from '../../views/StoredcardsWithCustprofilePage'

import {DinoContainer} from './dinoContainer';
import { CosmosContainer } from "./cosmosContainer";
import _ from "lodash";
//import {LoginabodeContainerCom} from '../../containers'


const {noop} = StaticRouter

const LazyCosmosContainerPage = lazy(() =>
  import("./cosmosPage")
);


const getLazyComponent = page => {
    switch (page) {
      case "CosmosContainer":
        return <LazyCosmosContainerPage />;
      
      default:
        return <div>404</div>;
    }
  };

function TacosListPage(){
    return <h3>Tacos List Page</h3>;
  
  }
  function Bus() {
    return <h3>Bus</h3>;
  }
class SVHeaderTmp extends React.Component{
    constructor(props){
        super(props)
        this.getFancyHtml = this.getFancyHtml.bind(this)
        this.extractVanillaPath = this.extractVanillaPath.bind(this)
        this.navClick = this.navClick.bind(this)
        this.state={
            vanilla_data: [
                {
                  selected:false,
                  fancyConfig:{
                    pufancy :false,
                    mychilds:[],
                    puto : '/bus'
                  },
                  icon: "icon-home",
                  menuDisp: "COSMOS(SVFlights)",
                  menuKey: "COSMOS(SVFlights)",
                  exact: true,
                  path: "/inetcosmos/svflysearch",
                  component: "getLazyHome"
                },
                {
                    selected:false,
                    fancyConfig:{
                        pufancy :false,
                        mychilds:[],
                        puto : '/bus'
                      },
                  icon: "icon-code",
                  menuDisp: "Abode",
                  menuKey: "Abode",
                  exact: true,
                  path: "/inetabode/svessearch",
                  component: "getLazyCode"
                },
              /*  {
                  selected:false,
                  fancyConfig:{
                      pufancy :false,
                      mychilds:[],
                      puto : '/bus'
                    },
                icon: "icon-code",
                menuDisp: "SJWills",
                menuKey: "SJWills",
                exact: true,
                path: "/isjpb/probate",
                component: "getLazyProbate"
              }, */
                {
                  selected:false,
                  fancyConfig:{
                      pufancy :false,
                      mychilds:[],
                      puto : '/bus'
                    },
                icon: "icon-code",
                menuDisp: "SOJOURNS",
               // menuDisp: "SVSojourns",
                menuKey: "SVSojourns",
                exact: true,
                path: "/inetsojourn/svsojourn",
                component: "getLazySojourn"
              },
                {
                    selected:false,
                    fancyConfig:{
                        pufancy :false,
                        mychilds:[
                            {
                              label:  "SVProfie",
                              path: "/myaccountSV/:id/svcustomer",
                              component: ReguserContainerCom
                            },
                            {
                                label:  "SV Storedcard List",
                              path:  "/myaccountSV/:id/mystoredcardList",
                              component: StoredcardsWithCustprofilePage
                            },
                            
                            {
                                label:  "SV MyCosmos List",
                              path: "myaccountSV/:id/svflighttripslist",
                              component: SVTPOrderComPage
                            }
                          ],
                        puto : '/bus'
                      },
                  icon: "icon-data",
                  menuDisp: "SVMy Reservations",
                  menuKey: "SVMy5Reservations",
                  exact: true,
                  path: "/svlogin",
                  component: "getLazyData"
                },
                {
                    selected:false,
                    fancyConfig:{
                        pufancy :false,
                        mychilds:[],
                        puto : '/bus'
                      },
                  icon: "icon-flows",
                  menuDisp: "SandwichesHeader",
                  menuKey: "SandwichesHeader",
                  exact: true,
                  path: "/sandwiches",
                  component: "getLazyFlows"
                },
                {
                    selected:false,
                    fancyConfig:{
                        pufancy :true,
                        mychilds:[
                            {
                              label:  "TacosListPagerFN",
                              path: "/tacos/list",
                              component: TacosListPage
                            },
                            {
                                label:  "TacosContainerPagerFN",
                              path: "/tacos/:id",
                              component: TacosContainerPage
                            },
                            
                            {
                                label:  "BusFN",
                              path: "/tacos/bus",
                              component: Bus
                            }
                          ],
                        puto : '/bus'
                      },
                  icon: "icon-jobs",
                  menuDisp: "TacosHeader",
                  menuKey: "TacosHeader",
                  exact: true,
                  path: "/tacos",
                  component: "getLazyJobs"
                }
              ],
            svClassValue:{
               0 :'active',
               1:'',
               2:'',
               3:'',
               4:''
            }
        }

    }
    getFancyHtml(svparams){
        if(svparams['mychilds'].length > 0){
            return ( <SVFancyNav svparams={svparams}></SVFancyNav>)
        }else{
            return (<noop></noop>)
        }
    }
    navClick(event){
        console.log('nav click')
        console.log(event.target.value)
    }
    extractVanillaPath(s){
        let nend =-1, p =-1
        nend =  s.indexOf('/',1) 

       if(nend > -1){
         p = s.substring(0,nend)
       }else{
           p = s
       }
       return p
    }

    render(){
        let mychilds  = [
            {
              label:  "TacosListPagerFN",
              path: "/tacos/list",
              component: TacosListPage
            },
            {
                label:  "TacosContainerPagerFN",
              path: "/tacos/:id",
              component: TacosContainerPage
            },
            
            {
                label:  "BusFN",
              path: "/tacos/bus",
              component: Bus
            }
          ]
        let page = 'CosmosContainer'
        console.log('sv nav')
        const nob = [{'rlink':'', 'rtitle':''}]
         /*history start*/
        const { location, to} = this.props
        let svIsActive =false
       
        let myname = to
       
        console.log(myname)
        let {pathname} = location
        console.log(pathname)
        pathname = this.extractVanillaPath(pathname)
        console.log('vanillaPath extracted:',pathname)

      

       const {vanilla_data} = this.state
       let vob =  _.find(vanilla_data, {'path':pathname})
       console.log(vob)
       if(vob && vob.fancyConfig && (vob.fancyConfig.pufancy === true )){
            console.log('sv******SVHeaderItem svIsActive true')
            svIsActive = true
            mychilds = vob.fancyConfig.mychilds
       }else{
            console.log('sv******SVHeaderItem svIsActive false')
            svIsActive = false
            mychilds = []
       }
      
      /*
        if (pathname == myname){
            console.log('sv******SVHeaderItem svIsActive true')
            svIsActive = true
        }else{
            console.log('sv******SVHeaderItem svIsActive false')
            svIsActive = false
        }
        */
         /*history end*/
        
        let svparams = {}
        svparams["mychilds"] = mychilds
        const {svClassValue} = this.state
        return ( 
    <noop>
            <div className="row" >
                <div html-content="<a href='http://localhost:8080/dashboard'>Go back to the classic SVRenaissance AI page</a>&nbsp;&nbsp;Or&nbsp;&nbsp;<a href='#' >Share information on our new SVRenaissance  AI-OpenStack page</a>" html-content2="<a href=''> Go back to the classic Portfolios page </a>" flag-value-name="TSP_TESTDRIVE" sticky-flag-name="isTDMinimized" min-max-cb="saveTestDrivePref" className="ng-isolate-scope">
                        <div id="testDrive" className="testdrive svr-classic"  aria-hidden="false">
                            <span className="html-content"><span className="ng-scope"><a href="http://localhost:8080/dashboard">Go back to the classic SVRenaissance AI page</a>&nbsp;&nbsp;Or&nbsp;&nbsp;<a href="#"  tabindex="0">Share information on our new SVRenaissance  AI-OpenStack page</a></span></span>
                            <div style={{"display":"none"}} className="close-container">
                                <button type="button" aria-label="Close Modal" className="close pull-right button"  tabindex="0">×</button>
                            </div>
                        </div>
                        <div className="pull-right tdMinMsg ng-hide"  aria-hidden="true" >
                            <span  className="html-content2" role="button" tabindex="0"><span className="ng-scope"><a href=""> Go back to the classic Portfolios page </a></span></span>
                        </div>
                </div>
            </div>
            <header className="page-header">
           

            <div className="row portfolio-page-title-cont">
                    <div className="pull-left">
                    <h3 style={{"padding-left": "10px"}}>SVRenaissance Networks</h3>
                    </div>  
                    <div  className="col-xs-auto voffset2 pull-right text-right text-muted page-refresh">
                    <span  className="et-icon-refresh  lastRefresh"></span>
                    
                    <span className="lastRefresh"> <Link  className="text-muted" to={`/svhome`}> <text style={{paddingRight:'5px'}}>Login</text><Icon  style={{ color: 'rgb(128,128,128)', fontSize:'14px' }} type="login" />   </Link> </span>
                    {/*  
                    <span className="lastRefresh">Last Refresh</span>
                    */}
                    <span  className="lastRefresh"></span>
                    </div>
                    <Suspense fallback={<p>Loading...</p>}>
                        {getLazyComponent(page)}
                    </Suspense>
                    
                {/*  
                
                    <div className="col-xs-6" style={{"display":"black"}}>
                        <ul id="subNavDiv" className="hopper-nav list-horizontal pull-right">
                            <li><strong>Open Stack</strong>
                            </li>
                            <li><a href="/etx/pw/watchlists">AWS Services</a>
                            </li>
                            <li><a href="/e/t/invest/vieworders">Services</a>
                            </li>
                            <li><a href="/e/t/accounts/txnhistory">Topology</a>
                            </li>
                        
                        </ul>
                    </div>
                */}
            </div>
            </header>
            {this.getFancyHtml(svparams)}
           
            {/* 
            
             <SVFancyNav svparams={svparams}></SVFancyNav>
                      <CosmosContainer></CosmosContainer>
                       <DinoContainer></DinoContainer>
                        <CosmosContainer></CosmosContainer>
                         

            */}
     
   
       
          
          

 
    </noop>
                
           
             

           

        )
       

    }

}

export const SVHeader = withRouter(SVHeaderTmp)
